import { Heading, IconNewWindow, Link } from 'braid-design-system';

import * as styles from './SectionHeadingLink.css';

export const SectionHeadingLink = ({
  href,
  children,
  id,
}: {
  href: string;
  children: React.ReactNode;
  id?: string;
}) => (
  <Heading level="4" id={id}>
    <Link href={href} className={styles.link} target="_blank">
      {children}
      &nbsp;
      <IconNewWindow alignY="lowercase" />
    </Link>
  </Heading>
);
